import { ModelLookupContext, ModelLookupProduct } from "@auer-steel/Contexts/ModelLookup/ModelLookupContext";
import MiniCart from "@auer-steel/CustomComponents/Cart/MiniCart";
import { createFromProduct } from "@insite/client-framework/Common/ProductInfo";
import { Dictionary } from "@insite/client-framework/Common/Types";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { getUnitNetPrice } from "@insite/client-framework/Services/Helpers/ProductPriceService";
import { batchGetProducts } from "@insite/client-framework/Services/ProductService";
import { GetProductRealTimePriceApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import addToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import translate from "@insite/client-framework/Translate";
import { BreakPriceDto, ProductDto, ProductPriceDto } from "@insite/client-framework/Types/ApiModels";
import { ProductPrimaryImageStyles } from "@insite/content-library/Components/ProductPrimaryImage";
import Button, { ButtonPresentationProps, ButtonProps } from "@insite/mobius/Button";
import { ClickablePresentationProps } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkProps } from "@insite/mobius/Link";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import TextField from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface ModelSearchListStyles {
    titleItem?: GridItemProps;
    title?: TypographyProps;
    container?: InjectableCss;
    productLineContainer?: GridContainerProps;
    innerBodyContainer?: GridContainerProps;
    detailsContainer?: GridContainerProps;
    lineItemRow?: GridItemProps;
    productLineItemColumn?: GridItemProps;
    innerProductLineContainer?: GridContainerProps;
    productLineImageItem?: GridItemProps;
    productLineImageClickable?: ClickablePresentationProps;
    productLineImage?: LazyImageProps;
    productLineNameLinkItem?: GridItemProps;
    productLineNameLink?: LinkProps;
    viewAllButtonItem?: GridItemProps;
    viewAllButton?: ButtonProps;
    fullPrimaryImageModal?: ModalPresentationProps;
    fullPrimaryImage?: ProductPrimaryImageStyles;
    imageGridItem?: GridItemProps;
    listItemsGridItem?: GridItemProps;
    listItemsGridItemDetails?: GridItemProps;
    partsListGridItem?: GridItemProps;
    partsListSection1?: GridItemProps;
    partsListSection2?: GridItemProps;
    partsListSection3?: GridItemProps;
    partsListGridItemAddToCart?: GridItemProps;
    bodyGridItem?: GridItemProps;
    titleTextStyleWrapper?: InjectableCss;
    titleText?: TypographyProps;
    pricingText?: TypographyProps;
    partNumberText?: TypographyProps;
    brandNameText?: TypographyProps;
    productTitleText?: TypographyProps;
    modelNumberText?: TypographyProps;
    imageStyle?: LazyImageProps;
    headingTextGridItem?: GridItemProps;
    productDataArea?: GridItemProps;
    imageArea?: GridItemProps;
    test?: GridItemProps;
    bodyContainer?: GridContainerProps;
    addToCartButton?: ButtonPresentationProps;
    pagination?: PaginationPresentationProps;
    qtyInputStyle?: InjectableCss;
    inlineSpinnerContainer?: GridItemProps;
    inlineSpinner?: InjectableCss;
    realTimePriceText?: TypographyPresentationProps;
}

export const styles: ModelSearchListStyles = {
    detailsContainer: {
        gap: 10,
        css: css`
            margin-top: 25px;
            margin-bottom: 25px;
        `,
    },
    titleItem: {
        width: 12,
        css: css`
            width: 100%;
            justify-content: center;
        `,
    },
    title: {
        variant: "h3",
        css: css`
            margin-bottom: 0;
        `,
    },
    container: {
        css: css`
            margin: 15px;
            height: 100%;
        `,
    },
    productLineContainer: {
        gap: 10,
    },
    innerProductLineContainer: {
        gap: 0,
        css: css`
            width: 100%;
        `,
    },
    productLineItemColumn: {
        width: [6, 6, 12, 12, 12],
    },
    lineItemRow: {
        width: [6],
    },
    productLineImageItem: {
        width: 12,
        align: "middle",
        css: css`
            width: 100%;
            height: 160px;
            justify-content: center;
        `,
    },
    productLineImageClickable: {
        css: css`
            img {
                height: 100%;
            }
        `,
    },
    productLineNameLinkItem: {
        width: 12,
        css: css`
            width: 100%;
            padding-bottom: 5px;
        `,
    },
    productLineNameLink: {
        typographyProps: {
            weight: "bold",
            css: css`
                width: 100%;
                overflow-wrap: break-word;
                word-wrap: break-word;
                text-align: center;
            `,
        },
        color: "text.main",
    },
    viewAllButtonItem: {
        width: 12,
        css: css`
            padding-top: 5px;
            width: 100%;
            justify-content: center;
        `,
    },
    viewAllButton: {
        typographyProps: {
            weight: "bold",
            ellipsis: true,
        },
    },
    fullPrimaryImageModal: {
        cssOverrides: {
            modalContainer: css`
                width: auto;
            `,
            modalBody: css`
                width: auto;
                max-width: initial;
                max-height: initial !important;
            `,
            modalTitle: css`
                border-bottom: none;
                padding: 10px 10px 0;
            `,
            modalContent: css`
                text-align: center;
            `,
        },
    },
    fullPrimaryImage: {
        image: {
            css: css`
                img {
                    width: auto;
                    max-height: 70vh;
                }
            `,
        },
    },
    imageGridItem: {
        width: [12, 12, 6, 6, 6],
    },
    listItemsGridItem: {
        width: [12, 12, 6, 6, 6],
    },
    listItemsGridItemDetails: {
        css: css`
            width: calc(100% + 10px) !important;
            margin-right: 20px;
        `,
    },
    partsListGridItem: {
        width: 12,
    },
    partsListGridItemAddToCart: {
        width: 6,
        css: css`
            display: flex;
            justify-content: space-between;
        `,
    },
    bodyGridItem: {
        width: 12,
    },
    partsListSection1: {
        width: 2,
    },
    partsListSection2: {
        width: 8,
    },
    partsListSection3: {
        width: 4,
    },
    titleTextStyleWrapper: {
        css: css`
            display: block;
            text-align: center;
        `,
    },
    headingTextGridItem: {
        width: [6, 6, 12, 12, 12],
        css: css`
            text-align: center;
        `,
    },
    titleText: {
        css: css`
            font-weight: 600;
            display: inline-block;
        `,
    },
    brandNameText: {
        css: css`
            font-size: 0.9em;
        `,
    },
    productTitleText: {
        css: css`
            font-size: 0.9em;
        `,
    },
    modelNumberText: {
        css: css`
            font-size: 0.9em;
        `,
    },
    pricingText: {
        css: css`
            font-weight: 600;
        `,
    },
    realTimePriceText: {
        weight: "bold",
        css: css`
            display: inline-block;
            text-align: left;
            min-width: 25px;

            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite 1s;
                content: "\\2026";
                width: 0;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `,
    },
    partNumberText: {
        css: css`
            font-weight: 600;
        `,
    },
    imageStyle: {
        css: css`
            img {
                height: 100%;
            }
        `,
    },
    bodyContainer: {
        gap: 0,
        css: css`
            width: 100%;
            padding-bottom: 15px;
            padding-top: 15px;
            border-bottom: 1px solid #ccc;
            margin-left: 15px;
        `,
    },
    innerBodyContainer: {
        gap: 0,
        css: css`
            width: 100%;
        `,
    },
    addToCartButton: {
        css: css`
            width: 100%;
        `,
    },
    qtyInputStyle: {
        css: css`
            width: 25px;
            display: flex;
            align-items: left;
        `,
    },
    inlineSpinnerContainer: {
        css: css`
            margin-right: 20px;
            position: relative;
        `,
    },
    inlineSpinner: {
        css: css`
            margin-right: 5px;
            position: relative;
            top: 5px;
        `,
    },
};

interface MatchedProduct {
    iscProduct: ProductDto;
    partNumber: string;
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        session: state.context.session,
    };
};

const mapDispatchToProps = {
    addToCart: makeHandlerChainAwaitable(addToCart),
    loadRealTimePricing,
    loadRealTimeInventory,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const ModelSearchListDetail: React.FC<Props> = ({ addToCart, session, loadRealTimePricing, loadRealTimeInventory }) => {
    const modelLookupContext = React.useContext(ModelLookupContext);
    const { isLoading, currentModelLookupProduct, currentSelectedGroup } = modelLookupContext;
    const productNumbers: string[] = [];
    const currentDrawingPdfPath = currentModelLookupProduct[0]?.drawingLink;
    const [startItemIndex, setStartItemIndex] = useState(0);
    const [currentPartsRange, setCurrentPartsRange] = useState(
        Object.values(currentModelLookupProduct).slice(startItemIndex, 10),
    );
    const [currentPage, setCurrentPage] = useState(1);
    const [resultsPerPage, setResultsPerPage] = useState(10);
    const [resultsCount, setResultsCount] = useState(Object.values(currentModelLookupProduct).length);
    const [displayImageContainer, setdisplayImageContainer] = useState(false);
    const [matchedProductsFound, setMatchedProductsFound] = useState([
        { iscProduct: {} as ProductDto, partNumber: "" },
    ]);

    const [productLineQty, setProductLineQty] = useState([{ productInfo: {} as ModelLookupProduct, qty: "1" }]);
    const toasterContext = React.useContext(ToasterContext);
    const [productPricingResults, setProductPricingResults] = useState([] as ProductPriceDto[] | null);

    if (isLoading) {
        return (
            <GridContainer>
                <GridItem>
                    <LoadingSpinner />
                </GridItem>
            </GridContainer>
        );
    }

    () => {
        Object.values(currentModelLookupProduct).map(partItem => {
            return productNumbers.push(partItem.partNumber);
        });
    };

    const changePage = (newPageIndex: number) => {
        const delta = newPageIndex * resultsPerPage;
        const calculatedIndex = delta - resultsPerPage > 0 ? delta - resultsPerPage : 0;
        const endItemIndex = calculatedIndex + resultsPerPage;

        setStartItemIndex(calculatedIndex);
        setCurrentPage(newPageIndex);
        setCurrentPartsRange(Object.values(currentModelLookupProduct).slice(calculatedIndex, endItemIndex));
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        setCurrentPartsRange(Object.values(currentModelLookupProduct).slice(0, newPageSize));
        setCurrentPage(1);
        setResultsPerPage(newPageSize);
    };

    const addProductToCart = async (productInfo: ModelLookupProduct) => {
        productInfo.showSpinner = true;
        const foundProduct = matchedProductsFound.find(product => product.partNumber === productInfo.partNumber);
        const qty = productLineQty.find(o => o.productInfo === productInfo)?.qty ?? "1";
        let qtyOnHand = 0;

        if (foundProduct) {
            loadRealTimeInventory({
                productIds: [foundProduct.iscProduct.id],
                onComplete: async realTimeInventoryProps => {
                    const inventoryDto = realTimeInventoryProps?.apiResult?.realTimeInventoryResults;
                    qtyOnHand = inventoryDto != null ? inventoryDto[0].qtyOnHand : 0;

                    await addToCart({
                        productId: foundProduct.iscProduct.id,
                        qtyOrdered: parseInt(qty!, 10),
                        unitOfMeasure: foundProduct.iscProduct.unitOfMeasure,
                    });

                    const qtyOrdered = parseInt(qty!, 10);
                    const price = getUnitNetPrice(foundProduct.iscProduct.pricing as ProductPriceDto, qtyOrdered || 1)
                        .priceDisplay;
                    toasterContext.addToast({
                        children: (
                            <MiniCart
                                addedProduct={foundProduct.iscProduct}
                                qty={qtyOrdered}
                                price={price}
                                inventory={qtyOnHand}
                            />
                        ),
                        messageType: "success",
                        timeoutLength: 8000,
                        iconProps: {
                            css: css`
                                display: none;
                            `,
                        },
                        cssOverrides: {
                            toast: css`
                                width: auto;
                                max-width: 550px;
                                border-width: 0.12em;
                                border-style: solid;
                                border-color: #000;
                            `,
                            toastBody: css`
                                margin-right: 1em !important;
                                width: 100%;
                            `,
                        },
                    });

                    productInfo.showSpinner = false;
                },
                onError: error => {
                    logger.debug(error);
                },
            });
        }
    };

    const mergeProductLists = (epiProductsList: (ProductDto | null)[], modelProductsList: ModelLookupProduct[]) => {
        const currentFoundMatches: MatchedProduct[] = Array<MatchedProduct>();

        Object.values(modelProductsList).forEach(currentModelLookupProduct => {
            epiProductsList?.forEach(productDto => {
                if (productDto !== null) {
                    const currentProductObject: MatchedProduct = {
                        iscProduct: productDto,
                        partNumber: currentModelLookupProduct.partNumber,
                    };

                    if (
                        productDto.erpNumber === currentModelLookupProduct.partNumber &&
                        !currentFoundMatches.includes(currentProductObject)
                    ) {
                        currentFoundMatches.push(currentProductObject);
                    }
                }
            });
        });

        if (currentFoundMatches && currentFoundMatches.length > 0) {
            setMatchedProductsFound(currentFoundMatches);
        }
    };

    const getProductForModelLookupItem = (modelLookupProduct: ModelLookupProduct): ProductDto | null => {
        try {
            const foundProduct = matchedProductsFound.find(
                product => product.partNumber === modelLookupProduct.partNumber,
            );

            if (foundProduct) {
                return foundProduct.iscProduct;
            }
        } catch (error) {
            return null;
        }

        return null;
    };

    useEffect(() => {
        async function fetchBatchProductData() {
            const productNumbers: string[] = [];

            setResultsCount(Object.values(currentModelLookupProduct).length);

            Object.values(currentModelLookupProduct).forEach(modelLookupProduct => {
                productNumbers.push(modelLookupProduct.partNumber);
            });

            const products = await batchGetProducts({
                extendedNames: productNumbers,
            });

            if (products !== null) {
                mergeProductLists(products, Object.values(currentModelLookupProduct));
            }
        }

        if (currentModelLookupProduct[0]) {
            fetchBatchProductData();
        }
    }, [currentModelLookupProduct]);

    useEffect(() => {
        changePage(1);
    }, [currentSelectedGroup]);

    useEffect(() => {
        // If all items are critical part, do not display image container.
        if (currentModelLookupProduct.every(part => part.criticalPart === "Yes")) {
            setdisplayImageContainer(false);
        } else {
            setdisplayImageContainer(true);
        }
    }, [currentModelLookupProduct]);

    // B2BES [AST-441] - MODIFY Customization - Include real time pricing and inventory
    useEffect(() => {
        // const [productPricingResults, ] = useState({});
        const arrayOfProductIds: GetProductRealTimePriceApiV2Parameter[] = [];

        Object.values(matchedProductsFound).forEach(async matchedProduct => {
            arrayOfProductIds.push({
                productId: matchedProduct!.iscProduct!.id,
                unitOfMeasure: matchedProduct.iscProduct!.unitOfMeasure,
                qtyOrdered: 1,
            });
        });
        // 1. Get array of product ids from matched products found
        // 2.
        const promise = new Promise<void>(resolve => {
            loadRealTimePricing({
                productPriceParameters: arrayOfProductIds,
                onSuccess: realTimePricing => {
                    setProductPricingResults(realTimePricing!.realTimePricingResults);

                    resolve();
                },
                onError: err => {
                    // TODO: Make a toast message
                    // product!.failedToLoadPricing = true;
                    logger.debug(err);
                    resolve();
                },
                onComplete(realTimePricingProps) {
                    if (realTimePricingProps.apiResult) {
                        this?.onSuccess?.(realTimePricingProps.apiResult);
                    } else if (realTimePricingProps?.error) {
                        this?.onError?.(realTimePricingProps.error);
                    }
                },
            });
        });

        promise.catch(() =>
            toasterContext.addToast({
                body: translate("Load realtime pricing and inventory failed"),
                messageType: "danger",
            }),
        );
    }, [matchedProductsFound]);

    const updateQty = (event: React.ChangeEvent<HTMLInputElement>, productLineQty: ModelLookupProduct) => {
        const value = event.target.value;
        setProductLineQty([{ productInfo: productLineQty, qty: value }]);
    };

    const moneyFormatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
    });

    return (
        <>
            <GridContainer {...styles.detailsContainer}>
                <GridItem {...styles.listItemsGridItem}>
                    <GridContainer {...styles.listItemsGridItemDetails}>
                        <Pagination
                            {...styles.pagination}
                            currentPage={currentPage}
                            resultsPerPage={resultsPerPage}
                            resultsCount={resultsCount}
                            resultsPerPageOptions={[10, 20, 50]}
                            onChangePage={changePage}
                            onChangeResultsPerPage={changeResultsPerPage}
                        />

                        {Object.entries(currentPartsRange)
                            .sort((a, b) => (a[1].sequenceNumber > b[1].sequenceNumber ? 1 : -1))
                            .map(([key, value], index) => {
                                const currentIscProduct = getProductForModelLookupItem(value);
                                const locatedLineQty = productLineQty.find(o => o.productInfo === value)?.qty;
                                const lineQty = locatedLineQty === undefined ? 1 : locatedLineQty;

                                let priceDisplay = "";
                                if (productPricingResults?.length) {
                                    const productPriceDto = productPricingResults?.find(
                                        o => o.productId === currentIscProduct?.id,
                                    ) as ProductPriceDto;

                                    if (productPriceDto) {
                                        priceDisplay = getUnitNetPrice(productPriceDto, 1).priceDisplay ?? null;
                                    }
                                }
                                return (
                                    <>
                                        <GridContainer {...styles.bodyContainer}>
                                            <GridItem {...styles.partsListSection2}>
                                                <GridContainer {...styles.innerBodyContainer}>
                                                    {currentIscProduct?.brand && (
                                                        <GridItem
                                                            key={currentIscProduct.id}
                                                            {...styles.partsListGridItem}
                                                        >
                                                            <Link href={`${currentIscProduct?.brand?.detailPagePath}`}>
                                                                {`${currentIscProduct?.brand?.name}`}
                                                            </Link>
                                                        </GridItem>
                                                    )}
                                                    <GridItem {...styles.partsListGridItem}>
                                                        <Link href={`${currentIscProduct?.productDetailUrl}`}>
                                                            {value.partDescription}
                                                        </Link>
                                                    </GridItem>
                                                    <GridItem {...styles.partsListGridItem}>
                                                        <Typography style={{ fontWeight: 600 }}>
                                                            {translate(`Part #: `)}
                                                        </Typography>
                                                        <Typography style={{ paddingLeft: "5px" }}>
                                                            {value.partNumber}
                                                        </Typography>
                                                    </GridItem>
                                                    <GridItem {...styles.partsListGridItem}>
                                                        <Typography style={{ fontWeight: 600 }}>
                                                            {translate(`Suggested Qty: `)}
                                                        </Typography>
                                                        <Typography style={{ paddingLeft: "5px" }}>
                                                            {translate(`${value.partQuantity}`)}
                                                        </Typography>
                                                    </GridItem>
                                                    <GridItem {...styles.partsListGridItem}>
                                                        <Typography style={{ fontWeight: 600 }}>
                                                            {translate(`Sequence #: `)}
                                                        </Typography>
                                                        <Typography style={{ paddingLeft: "5px" }}>
                                                            {translate(` ${value.sequenceNumber.replace(/^0+/, "")}`)}
                                                        </Typography>
                                                    </GridItem>
                                                    <GridItem {...styles.partsListGridItem}>
                                                        <Typography style={{ fontWeight: 600 }}>
                                                            {translate(`Critical Part: `)}
                                                        </Typography>
                                                        <Typography style={{ paddingLeft: "5px" }}>
                                                            {translate(` ${value.criticalPart}`)}
                                                        </Typography>
                                                    </GridItem>
                                                </GridContainer>
                                            </GridItem>
                                            <GridItem {...styles.partsListSection3}>
                                                <GridContainer {...styles.innerBodyContainer}>
                                                    {session?.isAuthenticated && currentIscProduct !== null && (
                                                        <>
                                                            <GridItem {...styles.partsListGridItem}>
                                                                {priceDisplay ? (
                                                                    <Typography {...styles.pricingText}>
                                                                        {priceDisplay && `${priceDisplay}`}
                                                                    </Typography>
                                                                ) : (
                                                                    <Typography {...styles.realTimePriceText}>
                                                                        {priceDisplay && `${priceDisplay}`}
                                                                    </Typography>
                                                                )}
                                                            </GridItem>
                                                            <GridItem {...styles.partsListGridItem}>
                                                                {session?.isAuthenticated && (
                                                                    <>
                                                                        <Typography style={{ width: "50px" }}>
                                                                            {translate("Qty: ")}
                                                                        </Typography>
                                                                        <TextField
                                                                            style={{ width: "80px" }}
                                                                            name="qtyTextField"
                                                                            value={lineQty}
                                                                            data-index={index}
                                                                            onChange={e => updateQty(e, value)}
                                                                        />
                                                                    </>
                                                                )}
                                                            </GridItem>
                                                            <GridItem {...styles.partsListGridItem}>
                                                                <GridItem {...styles.inlineSpinnerContainer}>
                                                                    {value.showSpinner && (
                                                                        <LoadingSpinner {...styles.inlineSpinner} />
                                                                    )}
                                                                </GridItem>

                                                                <Button
                                                                    style={{ marginTop: "5px" }}
                                                                    onClick={() => addProductToCart(value)}
                                                                    disabled={currentIscProduct === null}
                                                                >
                                                                    {translate("Add to Cart")}
                                                                </Button>
                                                            </GridItem>
                                                        </>
                                                    )}
                                                    {session?.isAuthenticated && currentIscProduct === null && (
                                                        <GridItem {...styles.partsListGridItem}>
                                                            <Typography>{translate("Non-stock product")}</Typography>
                                                        </GridItem>
                                                    )}
                                                </GridContainer>
                                            </GridItem>
                                        </GridContainer>
                                    </>
                                );
                            })}

                        <Pagination
                            {...styles.pagination}
                            currentPage={currentPage}
                            resultsPerPage={resultsPerPage}
                            resultsCount={resultsCount}
                            resultsPerPageOptions={[10, 20, 50]}
                            onChangePage={changePage}
                            onChangeResultsPerPage={changeResultsPerPage}
                        />
                    </GridContainer>
                </GridItem>
                {displayImageContainer && (
                    <GridItem {...styles.imageGridItem}>
                        <iframe src={currentDrawingPdfPath} width="100%" height="100%"></iframe>
                    </GridItem>
                )}
            </GridContainer>
        </>
    );
};

// TODO: Wrap this with productcontext.
export default connect(mapStateToProps, mapDispatchToProps)(ModelSearchListDetail);
